export default "__VITE_ASSET__Bc9gkOEj__"